import React, { FC,useEffect, useState } from "react";
import Link from "components/Link";
import YouTube from 'react-youtube';
import "../../../styles/styles.css"
import { Video } from "data/types";
import MediaVideo from "../../../components/PostFeaturedMedia/MediaVideo";
export interface CardVideoProps {
  video: Video;
}

const CardVideo :FC<CardVideoProps> = ({video}) => {
  const { href, title, videoUrl, date} = video;
  const [isPlay, setIsPlay] = useState(false);
  const [isHover, setIsHover] = useState(false);

  return (

        <div className="nc-Card10V2 relative flex flex-col"
            onMouseEnter={() => setIsHover(true)}
            onMouseLeave={() => setIsHover(false)}>
              <b>{title}</b>
             <div className="block group rounded-3xl flex-shrink-0 relative w-full aspect-w-16 aspect-h-12 sm:aspect-h-9 overflow-hidden z-0">
                <div>
                
                <MediaVideo isHover videoUrl={videoUrl} />;
                </div>
                <Link
                    href={href}
                    className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 transition-opacity"
                    >
                </Link>
            </div>
            {date}
        </div>
      
  );
};

export default CardVideo;
